import { render } from "./ExpiredClosedPage.vue?vue&type=template&id=637e84f0"
import script from "./ExpiredClosedPage.vue?vue&type=script&lang=js"
export * from "./ExpiredClosedPage.vue?vue&type=script&lang=js"

import "./ExpiredClosedPage.vue?vue&type=style&index=0&id=637e84f0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__